import { api } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/devices',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function deviceTypes(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/device-types',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('types', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function get(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: parseUrl('devices', queryParams),
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export async function createDevice(ctx, data) {
  try {
    let _data = data
    delete _data.$rules
    const response = await api({
      url: '/devices',
      method: 'POST',
      data: _data
    })
    return response
  } catch (e) {
    throw e
  }
}

export async function update(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: `/devices/${queryParams.id}`,
      data: queryParams.data,
      method: 'PUT'
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export async function remove(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: `/devices/${queryParams.id}`,
      method: 'DELETE'
    })
    return response
  } catch (e) {
    throw e
  }
}

export async function sync(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: parseUrlQr('devices', queryParams),
      method: 'GET'
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}

function parseUrlQr(state, params) {
  if (state && params.deviceToken) {
    return `/${state}/${params.deviceToken}/pair`
  }
  return `/${state}`
}

function parseUrl(state, params) {
  if (state && params.id) {
    return `/${state}/${params.id}`
  }
  return `/${state}`
}

